/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_ReadyInputs */

const en_directory_detail_signals_ai_ready = /** @type {(inputs: Directory_Detail_Signals_Ai_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready`)
};

const zh_directory_detail_signals_ai_ready = /** @type {(inputs: Directory_Detail_Signals_Ai_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready`)
};

/**
* | output |
* | --- |
* | "AI-Ready" |
*
* @param {Directory_Detail_Signals_Ai_ReadyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_ready = /** @type {((inputs?: Directory_Detail_Signals_Ai_ReadyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_ReadyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_ready(inputs)
	return zh_directory_detail_signals_ai_ready(inputs)
});
export { directory_detail_signals_ai_ready as "directory.detail.signals.ai_ready" }